import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";

import ContactImg from "../../assets/images/contact.png";

import "./Contact.css";

const Contact = () => {
  const [object, setObject] = useState();
  const [text, setText] = useState();
  const [certify, setCertify] = useState(false);

  const handleObject = (object) => {
    setObject(object);
  };

  const handleText = (text) => {
    setText(text);
  };

  const handleCertify = () => {
    setCertify(!certify);
  };

  const postData = async () => {
    const submitData = await axios
      .post("https://le-petit-recycleur-back.herokuapp.com/contact", {
        object: object,
        text: text,
        email: "",
      })
      .then((result) => {
        if (result) {
          Swal.fire({
            icon: "success",
            title: "Message bien envoyé !",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oups...",
            text: "Un problème est survenu lors de l'envoi du message.",
          });
        }
      });
  };

  const handleSubmitMessage = (e) => {
    e.preventDefault();
    if (certify) {
      if (object !== "Choisissez un objet" && object) {
        // postData();
        Swal.fire({
          icon: "success",
          title:
            "Merci pour votre message cependant cette fonctionnalité est en cours de déploiement.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Veuillez sélectionner un objet pour le message",
          timer: 2000,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Veuillez cocher la confirmation",
        timer: 2000,
      });
    }
  };

  return (
    <div className="ContactPage">
      <div className="background-decoration1"></div>
      <div className="background-decoration2"></div>
      <div className="background-decoration3"></div>

      <div className="ContactPage-desktop">
        <div className="ContactPage-logo-container">
          <img src={ContactImg} alt="contact" />
        </div>
        <form>
          <h2>Nous contacter</h2>

          <div className="form-group">
            <label htmlFor="objectContact">Objet :</label>
            <select
              className="form-control"
              id="objectContact"
              onChange={(e) => handleObject(e.target.value)}
            >
              <option value="Choisissez un objet">Choisissez un objet</option>
              <option value="Recommandations">Recommandations</option>
              <option value="Problème recyclage">Problème recyclage</option>
              <option value="Problème contribution">
                Problème contribution
              </option>
              <option value="Collaboration">Collaboration</option>
              <option value="Autre">Autre</option>
            </select>
          </div>

          {/* <div className="form-group">
              <label htmlFor="exampleFormControlInput1">Email address</label>
              <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com">
            </div> */}

          <div className="form-group">
            <label htmlFor="textContact">Message :</label>
            <textarea
              className="form-control"
              id="textContact"
              rows="5"
              onChange={(e) => handleText(e.target.value)}
            ></textarea>
          </div>

          <div className="form-check">
            <input
              className="form-check-input custom-check-input"
              type="checkbox"
              id="certifyContact"
              onChange={(e) => handleCertify(e.target.value)}
            />
            <label className="form-check-label" htmlFor="certifyContact">
              Je confirme le contenu de mon message
            </label>
          </div>
          {/* <a
            href={`mailto:langot.sylvain.contact@gmail.com?subject=${object}&body=${text}`}
          >
            <button className="btn btn-success">Envoyer</button>
          </a> */}
          <button
            type="submit"
            className="btn btn-success"
            onClick={(e) => handleSubmitMessage(e)}
          >
            Envoyer
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
